export default __webpack_public_path__ + "static/media/Icon1112.606cd914.svg";